var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8299 15.9219L11.7448 13.8542C10.7386 12.8564 10.2355 12.3575 9.65825 12.1751C9.1505 12.0147 8.60475 12.0206 8.1006 12.192C7.52735 12.3869 7.03517 12.8965 6.05085 13.9157L1.05511 18.8501M13.8299 15.9219L14.2566 15.4988C15.264 14.4998 15.7676 14.0002 16.3456 13.8179C16.8539 13.6575 17.4 13.6639 17.9045 13.8359C18.478 14.0314 18.9701 14.5424 19.9542 15.5642L21 16.6168M13.8299 15.9219L18.8437 20.9456M1.05511 18.8501C1.0939 19.1651 1.15995 19.4141 1.27249 19.635C1.51216 20.1054 1.89461 20.4879 2.36502 20.7275C2.8998 21 3.59986 21 5 21H17C17.8179 21 18.397 21 18.8437 20.9456M1.05511 18.8501C1 18.4026 1 17.8219 1 17V5C1 3.59987 1 2.8998 1.27249 2.36502C1.51216 1.89461 1.89461 1.51216 2.36502 1.27249C2.8998 1 3.59986 1 5 1H17C18.4001 1 19.1003 1 19.635 1.27249C20.1054 1.51216 20.4879 1.89461 20.7275 2.36502C21 2.8998 21 3.59987 21 5V16.6168M21 16.6168V17C21 18.4001 21 19.1003 20.7275 19.635C20.4879 20.1054 20.1054 20.4879 19.635 20.7275C19.4126 20.8409 19.1616 20.907 18.8437 20.9456M17.25 7.24986C17.25 8.63062 16.1307 9.74987 14.75 9.74987C13.3692 9.74987 12.25 8.63062 12.25 7.24986C12.25 5.86915 13.3692 4.74986 14.75 4.74986C16.1307 4.74986 17.25 5.86915 17.25 7.24986Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaGray);
export default __webpack_public_path__ + "static/media/MediaGray.4a4a348ed3d67ea396f018302cf9b18c.svg";
export { ForwardRef as ReactComponent };